import { ReportFeatures } from '@hcs/types';

import {
  COMP_PHOTO_CAROUSEL_FEATURES_RENTAL,
  COMP_PHOTO_CAROUSEL_FEATURES_SALE,
} from '../CompPhotoCarousel';

export const MAX_CARD_WIDTH = '460';

export const COMP_MARKER_POPUP_FEATURES_SALE = [
  ReportFeatures.CompsSelect,
  ...COMP_PHOTO_CAROUSEL_FEATURES_SALE,
];
export const COMP_MARKER_POPUP_FEATURES_RENTAL = [
  ReportFeatures.RentalCompsSelect,
  ...COMP_PHOTO_CAROUSEL_FEATURES_RENTAL,
];
